import { ColumnsOverview } from "../components/ColumnsOverview";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function ColumnsPage() {
  useDocumentTitle('Columns – qtplan');
  return <ColumnsOverview />;
}
